import 'css-chunksrc/client/scenes/attachDocuments/styles.scss';export default {
  "attachDocuments": "_attachDocuments_sz7rd_1",
  "buttons": "_buttons_sz7rd_5"
};